import { Operator } from './operator';

export class LessThan implements Operator {
	public evaluate(value: number, target: number): boolean {
		return value < target;
	}
}
